import { SvgIconProps } from "@mui/material";
import { FC } from "react";

export const CheckedCheckBoxIcon: FC<SvgIconProps> = ({
    width = 20,
    height = 20,
    stroke = "#D8D8D8",
    fill,
    ...rest
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox={"0 0 20 20"}
            xmlns={"http://www.w3.org/2000/svg"}
            fill={fill}
            {...rest}
        >
            <g clipPath={"url(#clip0_27_544)"}>
                <rect x={"0.5"} y={"0.5"} width={"19"} height={"19"} rx={"2.5"} stroke={stroke} />
                <path
                    fillRule={"evenodd"}
                    clipRule={"evenodd"}
                    fill={'#009DDE'}
                    d={
                        "M5.88484 10.3603C5.69342 10.1497 5.37056 10.137 5.16371 10.3318C4.95686 10.5267 4.94434 10.8554 5.13576 11.0659L7.7875 13.8333C7.98948 14.0556 8.33458 14.0556 8.53657 13.8333L14.8642 6.87231C15.0557 6.66173 15.0431 6.33306 14.8363 6.1382C14.6294 5.94334 14.3066 5.95608 14.1152 6.16666L8.16203 12.7157L5.88484 10.3603Z"
                    }
                />
            </g>
            <defs>
                <clipPath id={"clip0_27_544"}>
                    <rect width={"20"} height={"20"} fill={"white"} />
                </clipPath>
            </defs>
        </svg>
    );
};
